// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TokenService } from '@services/token.service';
import { takeWhile } from 'rxjs';

@Component({
    selector: 'app-token-verify',
    templateUrl: './token-verify.component.html',
    styleUrls: ['./token-verify.component.scss'],
})
export class TokenVerifyComponent implements OnInit, OnDestroy {
    public isLoading = true;
    public isComponentAlive = true;
    public invalidRequest = false;
    public expiredToken = false;

    constructor(
        private readonly route: ActivatedRoute,
        private readonly router: Router,
        private readonly tokenService: TokenService
    ) {}

    ngOnInit() {
        this.route.queryParams.pipe(takeWhile(() => this.isComponentAlive)).subscribe((params) => {
            if (params.token) {
                if (params.token === 'expired') {
                    this.expiredToken = true;
                    this.invalidRequest = false;
                    this.isLoading = false;
                } else if (params.token === 'invalid') {
                    this.expiredToken = false;
                    this.invalidRequest = true;
                    this.isLoading = false;
                } else {
                    const token = encodeURIComponent(params.token);
                    this.tokenService
                        .validateSecureOneTimeCode(token)
                        .pipe(takeWhile(() => this.isComponentAlive))
                        .subscribe((result) => {
                            if (result) {
                                if (result.expired) {
                                    this.expiredToken = true;
                                } else if (result.error) {
                                    this.invalidRequest = true;
                                } else if (result.encryptedToken && result.dealId) {
                                    // Router will automatically encode query params
                                    // Sinced encryptedToken is already encrypted it will
                                    // encrypt it again breaking the token
                                    this.router.navigate(['upload', result.dealId], {
                                        state: result,
                                        queryParams: {
                                            token: params.token,
                                        },
                                    });
                                }
                            } else {
                                this.invalidRequest = true;
                            }
                        });

                    this.isLoading = false;
                }
            } else {
                //invalid call
                this.invalidRequest = true;
                this.isLoading = false;
            }
        });
    }

    gotToLogin() {
        this.router.navigate(['login']);
    }

    ngOnDestroy(): void {
        this.isComponentAlive = false;
    }
}
